//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['company', 'disableActions'],
    data: function data() {
        var columns = [{
            name: 'last_exported_at',
            label: trans('columns.export'),
            sortable: true,
            html: true,
            data: function data(item) {
                return item.last_exported_at == null ? '<i class="fa fa-star"></i>' : '';
            }
        }, {
            name: 'name',
            label: trans('columns.name'),
            sortable: true
        }, {
            name: 'type',
            label: 'Typ',
            column: 'externally_provided',
            sortable: true,
            data: function data(item) {
                return item.externally_provided ? 'Finktec-verwaltet' : 'Kunden-Info';
            }
        }];

        if (!(this.company > 0)) {
            columns.push({
                name: 'company',
                label: trans('columns.company_name'),
                sortable: false,
                data: function data(item) {
                    return item.company ? item.company.name : '–';
                }
            });
        }

        return {
            url: route('sanctum_api.info-projects.index'),
            columns: columns
        };
    },

    methods: {
        buildRequestData: function buildRequestData() {
            if (this.company > 0) {
                return {
                    company: this.company
                };
            }
            return {};
        },
        canEdit: function canEdit(data) {
            if (this.disableActions) {
                return false;
            }
            if (Laravel.roles.includes('fieldservice')) {
                return data.externally_provided;
            } else if (Laravel.user.level <= 100 && data.externally_provided) {
                return false;
            }

            return Laravel.user.level >= 100;
        },
        deleteProject: function deleteProject(projectId) {
            var url = route('info-projects.delete', projectId);

            window.swal({
                title: window.i18n.messages.confirm_header,
                text: window.i18n.messages.confirm_delete,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.delete(url).then(function (response) {
                        window.swal({
                            title: window.i18n.messages.success,
                            html: window.i18n.messages.delete_success,
                            type: 'success',
                            timer: 1000,
                            showConfirmButton: false
                        }).then(function () {
                            window.location.reload();
                        });
                    }).catch(function (error) {
                        window.swal({
                            title: window.i18n.messages.error,
                            html: window.i18n.messages.delete_error,
                            type: 'error'
                        });
                    });
                }
            });
        },
        publishProject: function publishProject(projectId) {
            var url = route('info-projects.publish', projectId);

            window.swal({
                title: trans('info_projects.index.publish_confirmation_title'),
                text: trans('info_projects.index.publish_confirmation_text'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.post(url).then(function (response) {
                        window.swal({
                            title: window.i18n.messages.success,
                            html: trans('info_projects.index.publish_success'),
                            type: 'info'
                        });
                    }).catch(function (error) {
                        window.swal({
                            title: window.i18n.messages.error,
                            html: trans('info_projects.index.publish_error'),
                            type: 'error'
                        });
                    });
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/InfoProjects.vue
// module id = 52
// module chunks = 0